export enum TableActionColor {
  primary,
  accent,
  warn
}
